import HeatmapChart from '@/ui//charts/heatmapChart/HeatmapChart';
import { Container, TitleWrapper, Title, ChartWrapper } from './EsgRiskSignal.styles';
import RangeBar from '@/ui//bars/rangeBar/RangeBar';
import { REDCOLORSET } from '@/styles/colorTheme';
import { useTranslation } from 'react-i18next';

const EsgRiskSignal = ({ data, isLoading }) => {
  const [t] = useTranslation('dashboard');

  return (
    <div className="border rounded-lg p-4">
      <TitleWrapper>
        <Title>
          <div className="text-text-500">{t('ESG Risk Signal')}</div>
          <div className="text-text-200 text-sm">
            {t('Distribution of ESG risks for the companies on my watchlist at a glance.')}
          </div>
        </Title>
        <RangeBar
          ranges={[
            { value: 80, color: REDCOLORSET[4] },
            { value: 60, color: REDCOLORSET[3] },
            { value: 40, color: REDCOLORSET[2] },
            { value: 20, color: REDCOLORSET[1] },
            { value: 0, color: REDCOLORSET[0] },
          ]}
        />
      </TitleWrapper>
      <div className="mt-4 overflow-x-auto">
        <HeatmapChart data={data} isLoading={isLoading} />
      </div>
    </div>
  );
};

export default EsgRiskSignal;
